import React, { useState } from "react";
import Section from "../components/Section";
import ProjectCard from "../components/ProjectCard";
import projectsData from "../data/projects.json";

export default function Projects() {
  const [flashError, setFlashError] = useState(false);
  const [vanishingElements, setVanishingElements] = useState({
    title: false,
    description: false,
    tags: false,
    ghost: false
  });
  const projects = projectsData.projects || [];

  const handleProject404Click = () => {
    setFlashError(true);
    setTimeout(() => setFlashError(false), 500);
  };

  const handleElementVanish = (element: string) => {
    setVanishingElements((prev) => ({ ...prev, [element]: true }));
    if (element === "ghost") {
      setTimeout(() => {
        setVanishingElements((prev) => ({ ...prev, ghost: false }));
      }, 4000);
    }
  };

  return (
    <main className="min-h-screen">
      <Section title="Projects" eyebrow="selected work" containerClassName="max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-fr items-stretch">
          {projects.map((p: any) => {
            const isProject404 = p.slug === "project-404";
            return (
              <div
                key={p.name}
                className={`relative transition h-full ${flashError && isProject404 ? "flash-error" : ""}`}
              >
                <ProjectCard
                  project={p}
                  onClick={isProject404 ? handleProject404Click : undefined}
                  onElementVanish={isProject404 ? handleElementVanish : undefined}
                  vanishingElements={isProject404 ? vanishingElements : undefined}
                />
                {flashError && isProject404 && (
                  <div className="absolute top-2 right-2 text-red-500 text-2xl font-bold fade-in-out pointer-events-none">
                    ✕
                  </div>
                )}
                {vanishingElements.ghost && isProject404 && (
                  <div className="absolute inset-0 pointer-events-none z-10">
                    <div
                      className="ghost-passing text-white text-6xl font-bold opacity-50"
                      style={{ fontFamily: "monospace" }}
                    >
                      👻
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Section>
    </main>
  );
}
